import 'widget/components/VehicleExtraCta/VehicleExtraCtaItem/VehicleExtraCtaItem.scss';

import React from 'react';
import PropTypes from 'prop-types';
import MediaQuery from 'react-responsive';
import { MEDIA_QUERIES } from '@sm360/widget-commons-general';

const VehicleExtraCtaItem = ({ image, tagline, button, onClick }) => {
    return (
        <div className="vehicle-extra-cta-item--container">
            <MediaQuery maxWidth={MEDIA_QUERIES.MOBILE.MAX}>
                <div className="vehicle-extra-cta-item--content is-mobile">
                    <button className="sr-button-1 is-centered is-fluid" onClick={onClick}>
                        {button}
                    </button>
                </div>
            </MediaQuery>
            <MediaQuery minWidth={MEDIA_QUERIES.MOBILE.MAX}>
                <div className="vehicle-extra-cta-item--content">
                    <img src={image} alt={tagline} className="vehicle-extra-cta-item--image is-centered" />
                    <h3 className="sr-subtitle-2 is-centered vehicle-extra-cta-item--subtitle">{tagline}</h3>
                    <button className="sr-button-1 is-centered" onClick={onClick}>
                        {button}
                    </button>
                </div>
            </MediaQuery>
        </div>
    );
};

VehicleExtraCtaItem.propTypes = {
    image: PropTypes.string.isRequired,
    tagline: PropTypes.string.isRequired,
    button: PropTypes.string.isRequired,
    onClick: PropTypes.func.isRequired,
};

VehicleExtraCtaItem.displayname = 'VehicleExtraCtaItem';

export default VehicleExtraCtaItem;
